import { createAsyncThunk } from '@reduxjs/toolkit';

const getExternalUsers = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/account/users?scope=external');
    return result;
  } catch (e) {}
};

export const fetchExtAccountUsers = createAsyncThunk(
  'externalAccountUsers/fetch/all',
  getExternalUsers
);
